<template>
  <div class="extraction">
	<extract-header></extract-header>
    <div class="container">
	  <router-view></router-view>
    </div>
	  <loading-absolute v-if="$store.state.showLoading"></loading-absolute>
  </div>
</template>

<script>
import extractHeader from "../common/ExtractHeader"
import LoadingAbsolute from '../common/LoadingAbsolute'
export default {
	components:{
		extractHeader,LoadingAbsolute
	},
	data(){
		return {
			
		}
	},
	
};
</script>

<style scoped lang="scss">
.extraction {
	width: 100%;
	background-color: #f7f7f7;
	.container {
		width: 1200px;
		padding: 20px 0;
		margin: 0 auto;
		position: relative;
	}
}
</style>